import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgMildIrritationSelectedEmoji(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 40c8.837 0 16-7.163 16-16S32.837 8 24 8 8 15.163 8 24s7.163 16 16 16Zm8.6-16.7a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0ZM33 29a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.5-1.8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM35 29a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm-21.3-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm.5-.8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.5.8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm1.2-4a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Zm4.2 5.125h6.6v-1.25h-6.6v1.25Z",
    fill: "currentColor"
  }));
}

export { SvgMildIrritationSelectedEmoji as default };
